export default {
    bind (element, binding, vnode) {
        function documentHandler (event) {
            if (element.contains(event.target)) {
                return false
            }
            if (binding.expression) {
                binding.value(event)
            }
        }
        element.__vueClickOutside__ = documentHandler
        document.addEventListener('click', documentHandler)
    },
    unbind (element, binding) {
        document.removeEventListener('click', element.__vueClickOutside__)
        delete element.__vueClickOutside__
    }
}



// WEBPACK FOOTER //
// ./src/mixins/shared/clickoutside.js